import React from 'react';
// import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './components/Header/Header';
import Body from './components/Body/Body';



// import fakeData from './fakeData/fakedata';



// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faCoffee } from '@fortawesome/free-solid-svg-icons'; //this line is for fontawesome

/* <FontAwesomeIcon icon= {faCoffee} />  */
// import { Button } from 'react-bootstrap'; //this line is for bootstrap

function App() {
  return (
    <div className="App">
       <Header></Header>
       <Body></Body>
       
       
       
       
    </div>
  );
}


export default App;
